import ConnectedComponent from './DocumentContainer';

export default ConnectedComponent;